import {
  EMAILRULE_TICKET_GET_DATA,
  EMAIL_RULE_GET_DETAILS_DATA,
  EMAILRULE_FORM_ADD_DATA,
  EMAILRULE_UPDATE_DATA,
  EMAILRULE_DELETE_DATA,
} from "./Constants";

const initialState = {
  loading: false,
  error: null,
  emailrulelist: {},
  emailrules: {},
  emailrule: {},
  emailruleform: {},
  addSuccess: false,
  updateSuccess: false,
  deleteSuccess: false,  
};

const Reducer = (state = initialState, action) => {
  switch (action.type) {

    //load all list
    case EMAILRULE_TICKET_GET_DATA.EMAILRULE_TICKET_GET_DATA_LOAD:
      return {
        ...state,
        loading: true,
        emailrulelist: {},
        error: null,
      };
    case EMAILRULE_TICKET_GET_DATA.EMAILRULE_TICKET_GET_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        emailrulelist: { data: action.emailrulelist },
      };
    case EMAILRULE_TICKET_GET_DATA.EMAILRULE_TICKET_GET_DATA_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    
    //Get by id
    case EMAIL_RULE_GET_DETAILS_DATA.EMAIL_RULE_GET_DETAILS_DATA_LOAD:
      return {
        ...state,
        loading: true,
        emailrule: {},
        error: null,
      };
    case EMAIL_RULE_GET_DETAILS_DATA.EMAIL_RULE_GET_DETAILS_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        emailrule: action.emailrule,
        error: null,
      };
    case EMAIL_RULE_GET_DETAILS_DATA.EMAIL_RULE_GET_DETAILS_DATA_FAIL:
      return {
        ...state,
        loading: false,
        emailrule: {},
        error: action.error,
      };
    // Add 
    case EMAILRULE_FORM_ADD_DATA.EMAILRULE_FORM_ADD_DATA_LOAD:
      return {
        ...state,
        loading: true,
        emailruleform: {},
        addSuccess: false,
        error: null,
      };
    case EMAILRULE_FORM_ADD_DATA.EMAILRULE_FORM_ADD_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        emailruleform: action.emailruleform,
        addSuccess: true,
        error: null,
      };
    case EMAILRULE_FORM_ADD_DATA.EMAILRULE_FORM_ADD_DATA_FAIL:
      return {
        ...state,
        loading: false,
        emailruleform: {},
        addSuccess: false,
        error: action.error,
      };
    case EMAILRULE_FORM_ADD_DATA.EMAILRULE_FORM_ADD_DATA_RESET:
      return {
        ...state,
        loading: false,
        emailruleform: {},
        addSuccess: false,
        error: null,
      };  
    // Update 
    case EMAILRULE_UPDATE_DATA.EMAILRULE_UPDATE_DATA_LOAD:
      return {
        ...state,
        loading: true,
        updateSuccess:false,
        error: null
      }
    case EMAILRULE_UPDATE_DATA.EMAILRULE_UPDATE_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        emailrule: action.emailrule,
        updateSuccess: true,
        error: false
      }
    case EMAILRULE_UPDATE_DATA.EMAILRULE_UPDATE_DATA_FAIL:
      return {
        ...state,
        loading: false,
        updateSuccess:false,
        error: action.error
      }

    case EMAILRULE_UPDATE_DATA.EMAILRULE_UPDATE_DATA_RESET:
      return {
        ...state,
        loading: false,
        emailrule: {},
        emailruleform: {},
        emailrules: [],
        updateSuccess:false,
        error: null
      };

    // Delete 
    case EMAILRULE_DELETE_DATA.EMAILRULE_DELETE_LOAD:
      return {
        ...state,
        loading: true,
        emailrule: {},
        deleteSuccess: false,
        error: null,
      };
    case EMAILRULE_DELETE_DATA.EMAILRULE_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        //emailrule: action.emailrule,
        deleteSuccess: true,
        error: null,
      };
    case EMAILRULE_DELETE_DATA.EMAILRULE_DELETE_FAIL:
      return {
        ...state,
        loading: false,
        emailrule: {},
        deleteSuccess: false,
        error: action.error,
      };
    case EMAILRULE_DELETE_DATA.EMAILRULE_DELETE_RESET:
      return {
        ...state,
        loading: false,
        emailrule: {},
        deleteSuccess: false,
        error: null,
      };  
    

    default:
      return {
        ...state,
      };
  }
};
export default Reducer;